import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import { getDashboardData } from "./service";

/**
 * get dashboard data
 */
function* getDashboardRecord({ postData }) {
  try {
    const { data } = yield call(getDashboardData, postData);
    console.log("dashboard data", data);
    yield put({
      type: Actions.GET_DASHBOARD_RECORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_DASHBOARD_RECORD_ERROR,
      error: error,
    });
  }
}

export default function* dashboardSaga() {
  yield takeEvery(Actions.GET_DASHBOARD_RECORD, getDashboardRecord);
}
